import { ComponentProps } from "react";
import { ProjectColor } from "../../../../utils/tokens/projectColors";

const Project = process.env.REACT_APP_PROJECT;

type DropPlusIconProps = ComponentProps<"svg">;
export const DropPlusIcon = (props: DropPlusIconProps) => {
  return (
    <svg
      width="52"
      height="51"
      viewBox="0 0 52 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <ellipse
        cx="25.6135"
        cy="25.5"
        rx="25.6135"
        ry="25.5"
        fill={ProjectColor[Project]}
      />
      <path
        d="M37.5243 29.8419H27.7323V40.1619H24.2523V29.8419H14.5083V26.6019H24.2523V16.3539H27.7323V26.6019H37.5243V29.8419Z"
        fill="white"
      />
    </svg>
  );
};
